module.exports = __webpack_public_path__ + "img/hopper@3x.a65e421e.png";